import { useState } from "react";

interface configButton {
    iconButton?: string;
    labelButton?: string;
    _disableButton?: boolean
}


interface Props {
    _value: string;
    buttonClick: Function;
    onChange: Function;
    _label?: string;
    ButtonProps?: configButton;
    _disable?: boolean;
}

export const InputButton = ({ _label, buttonClick, ButtonProps, onChange, _value, _disable }: Props) => {

    const setValue = (typed) => {
        onChange(typed)
    }

    return (
        <>
            <label>{_label ?? "Sin Titulo"}</label>
            <div className="input-group">
                <input
                    disabled={_disable}
                    type="text"
                    className="form-control"
                    aria-label="Recipient's username"
                    aria-describedby="button-addon2"
                    value={_value}
                    onChange={(e) => { setValue(e.target.value) }}
                />
                <button disabled={ButtonProps?._disableButton} className="btn btn-primary shadow-none" type="button" id="button-search" onClick={() => { buttonClick() }}>
                    <i className={`${ButtonProps?.iconButton ?? ""} label-icon align-middle `} />
                    {ButtonProps?.labelButton ?? "Buscar"}
                </button>
            </div>
        </>
    )
}